import { RootState } from '@reducers';

export const selectInsurancePolicyListPageReducer = (state: RootState) => state.userDashboardRouteReducer.insurancePolicyListPageReducer;
